import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "media-highlight"
}
const _hoisted_2 = { class: "media-highlight__media" }

import {
  computed, onMounted, ref, onBeforeUnmount,
} from 'vue';
import useBanners from '@/composables/useBanners';
import MediaHighlightSlider from './MediaHighlightSlider.vue';
import MediaHighlightTextContent from './MediaHighlightTextContent.vue';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'MediaHighlight',
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const fields = computed(() => props.block?.fields || {});
const tagline = computed(() => fields.value.Tagline);
const title = computed(() => fields.value.Title);
const text = computed(() => fields.value.Text);
const { banners } = useBanners(props.block.fields.Banners, 'media-highlight');

const isDesktop = ref(false);

onMounted(async () => {
  window.addEventListener('resize', updateIsDesktop);
  updateIsDesktop();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateIsDesktop);
});

function updateIsDesktop() {
  isDesktop.value = window.innerWidth < 1024;
}

const mediaWidthToHeightRatio = computed(() => (isDesktop.value ? 60 : 70));

return (_ctx: any,_cache: any) => {
  return (_unref(banners).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(MediaHighlightTextContent, {
          tagline: _unref(tagline),
          title: _unref(title),
          text: _unref(text)
        }, null, 8, ["tagline", "title", "text"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(MediaHighlightSlider, {
            banners: _unref(banners),
            "width-to-height-ratio": _unref(mediaWidthToHeightRatio)
          }, null, 8, ["banners", "width-to-height-ratio"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})